"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_LIST_SKELETON = exports.DEFAULT_PRODUCT_BOX_LIST_SKELETON_COUNT = void 0;
const DEFAULT_PRODUCT_BOX_LIST_SKELETON_COUNT = exports.DEFAULT_PRODUCT_BOX_LIST_SKELETON_COUNT = 12;
const PRODUCT_LIST_SKELETON = exports.PRODUCT_LIST_SKELETON = 'product-list-skeleton';
